import { cn } from "@/lib/utils"

import { type PartnerInfo } from "./types"

/** Wordmark if the partner has one, then a square mark beside the name, then
 *  the name alone set in the display serif. */
export function Brand({
  partner,
  className,
}: {
  partner: PartnerInfo
  className?: string
}) {
  if (partner.logo_wordmark_url) {
    return (
      <img
        src={partner.logo_wordmark_url}
        alt={partner.name}
        className={cn("h-7 w-auto", className)}
      />
    )
  }
  if (partner.logo_url) {
    return (
      <span className={cn("flex items-center gap-2", className)}>
        <img
          src={partner.logo_url}
          alt=""
          aria-hidden="true"
          className="size-7 w-auto shrink-0 rounded-lg"
        />
        {/* The mark holds its size; the name is what gives way when a long
            partner name meets a narrow viewport. */}
        <span className="font-lp-serif text-lp-fg truncate text-lg">
          {partner.name}
        </span>
      </span>
    )
  }
  return (
    <span className={cn("font-lp-serif text-lp-fg text-lg", className)}>
      {partner.name}
    </span>
  )
}
